import React, { useState, useEffect } from "react";
import { Input, Form, Button, Divider, message, Card, Row, Col, Checkbox, Tooltip } from "antd";
import type { CheckboxChangeEvent } from "antd/es/checkbox";
import styles from "./../../style.module.scss";
import { useTranslation } from "react-i18next";
import { CoordinateVerify } from "../../../../Utility/RegExp";
import { useUpdateDeviceData, useReport } from "../../queries";
import { setDeviceId, setTicketVisible, setCenterPosition, setIsEdit } from "../../goSlice";
import { useAppSelector, useAppDispatch } from "store/hook";

import { BiEdit } from "react-icons/bi";
import { RiMapPinLine } from "react-icons/ri";

// interface createInfoProps {
//   ModalVisible: boolean;
//   setModalVisible: (arg: boolean) => void;
// }

const Edit = React.memo((props: any) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { mutateAsync: updateDeviceDataMutation, isLoading: createCustomerInfLoading } = useUpdateDeviceData();
  const { mutateAsync: useReportMutation } = useReport();

  const { stateCid, level, loginCid, time_zone } = useAppSelector((state) => state.global);
  const { deviceId, ticketData } = useAppSelector((state) => state.goPage);

  const handleSubmit = (values: any) => {
    updateDeviceDataMutation({ values })
      .then((res) => {
        dispatch(setDeviceId(res.id));
        dispatch(setCenterPosition(res.lat_long === null ? [0, 0] : res.lat_long));
        dispatch(setTicketVisible(false));
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  //limite the input value to be mulitples of 30
  // const aliveNumberChange = (value: number) => {
  //   let newValue = Math.round(value / 30) * 30;
  //   form.setFieldsValue({ period_alive: newValue });
  // };

  // ==================================  取得使用地理位置權限 START ==================================
  const handlePermissionsGranted = () => {
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: "geolocation" }).then((result) => {
        // PermissionStatus.status => Returns the state of a requested permission; one of 'granted', 'denied', or 'prompt'. Later versions of the specification replace this with PermissionStatus.state.
        if (result.state === "granted" || "prompt") {
          getCoordinates();
        } else if (result.state === "denied") {
          result.onchange = () => {
            handlePermissionsGranted();
          };
        }
        // Don't do anything if the permission was denied.
      });
    } else if (navigator.geolocation) {
      getCoordinates();
    }
  };
  // ==================================  取得使用地理位置權限 END ==================================

  // ==================================  取得座標位置 START ==================================
  const successCallback = (position: any) => {
    let latitude = position.coords.latitude;
    let longitude = position.coords.longitude;

    form.setFieldValue("lat_long", `${latitude},${longitude}`);
  };

  const errorCallback = (error: any) => {
    // 使用手機版瀏覽器會進入這裡
    // 出現錯誤 [object GeolocationPositionError]
    // error.message 可查看錯誤訊息
    console.log("error", error);
  };

  const getCoordinates = () => {
    if (!navigator.geolocation) {
      message.error("Geolocation is not supported by your browser");
      return;
    } else {
      navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    }
  };
  // ==================================  取得座標位置 END ==================================

  const onReset = () => {
    form.resetFields(["location", "name", "lat_long"]);
  };

  useEffect(() => {
    // 只要進入編輯頁面就設為 true -> 避免 map 中心跳回小黃人位置
    dispatch(setIsEdit(true));

    form.setFieldsValue({
      cid: ticketData?.ticket_inf?.cid,
      ticket: ticketData?.ticket_inf?.ticket,
      id: deviceId,
      location: ticketData?.node_inf?.[deviceId]?.location,
      name: ticketData?.node_inf?.[deviceId]?.name,
      lat_long: `${ticketData?.node_inf?.[deviceId]?.["lat_long"]?.[0]?.toFixed(12)},${ticketData?.node_inf?.[
        deviceId
      ]?.["lat_long"]?.[1]?.toFixed(12)}`,
    });
  }, []);

  return (
    <>
      <Card title={t("ISMS.EditDevice")} className={`${styles.Card}`}>
        <Form onFinish={handleSubmit} form={form} layout="vertical">
          <div className="formwrap">
            <Row gutter={24} justify="space-around">
              <Col xs={24} sm={24} md={24} lg={24} xl={10}>
                {/* <h2>{t("ISMS.TicketInfo")}</h2> */}
                {/* <Divider className={styles.divider} /> */}

                <Form.Item name={"cid"} hidden={true}>
                  <Input />
                </Form.Item>

                <Form.Item name={"ticket"} hidden={true}>
                  <Input />
                </Form.Item>

                <Form.Item name={"id"} label={t("ISMS.DeviceId")} className={styles.formItem}>
                  <Input placeholder={""} maxLength={30} disabled={true} />
                </Form.Item>

                <Form.Item name={"location"} label={t("ISMS.Location")}>
                  <Input placeholder={""} maxLength={30} />
                </Form.Item>

                <Form.Item name={"name"} label={t("ISMS.Name")}>
                  <Input placeholder={""} maxLength={30} />
                </Form.Item>

                <Form.Item
                  name={"lat_long"}
                  label={t("ISMS.GPS")}
                  className={styles.formItem}
                  rules={[CoordinateVerify]}
                >
                  <Input
                    placeholder={"24.000000,120.000000"}
                    maxLength={40}
                    addonAfter={<RiMapPinLine className={styles.addonAfterIcon} onClick={handlePermissionsGranted} />}
                  />
                </Form.Item>
              </Col>

              <Divider />
            </Row>
            <Row gutter={24} justify="end">
              <Col>
                <Form.Item style={{ margin: 0 }}>
                  <Button style={{ marginRight: 10 }} htmlType="button" onClick={onReset}>
                    {t("ISMS.Reset")}
                  </Button>
                  <Button style={{ marginRight: 10 }} onClick={() => dispatch(setTicketVisible(false))}>
                    {t("ISMS.Cancel")}
                  </Button>
                  <Button type="primary" htmlType="submit">
                    {t("ISMS.Submit")}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </Card>
    </>
  );
});

export default Edit;
